import KeyedAndNamedDto from 'modules/base/dto/KeyedAndNamedDto';

export class FmStoragePermissionDto extends KeyedAndNamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.user = null;
		/** @type {number} */
		this.userGroup = null;
		/** @type {string} */
		this.grantedLevel = null;
	}

	/**
	 * @typedef {Object} _FmStoragePermissionDtoProps
	 * @property {number} user
	 * @property {number} userGroup
	 * @property {string} grantedLevel
	 * @typedef {import("../KeyedAndNamedDto").KeyedAndNamedDtoProps & _FmStoragePermissionDtoProps} FmStoragePermissionDtoProps
	 */
	/**
	 *
	 * @param {FmStoragePermissionDtoProps} props
	 * @returns {FmStoragePermissionDto}
	 */
	setup(props) {
		super.setup(props);
		this.user = props.user;
		this.userGroup = props.userGroup;
		this.grantedLevel = props.grantedLevel;
		return this;
	}
}

export default FmStoragePermissionDto;
